import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../auth/auth.service';
import { AboutComponent } from '../core/about.component';

import * as Sentry from '@sentry/angular';

@Component({
  selector: 'oc-profile-menu',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  template: ` <div ngbDropdown>
    <div ngbDropdownToggle>
      <ng-content></ng-content>
    </div>
    <div ngbDropdownMenu>
      <button ngbDropdownItem (click)="about()">About Oracy Champions</button>
      <div class="dropdown-divider"></div>
      <button ngbDropdownItem (click)="logout()">Log out</button>
    </div>
  </div>`,
  styles: `
    .dropdown-toggle::after {
      display: none;
    }
  `,
})
export class ProfileMenuComponent {
  private auth = inject(AuthService);
  private modalService = inject(NgbModal);

  about() {
    this.modalService.open(AboutComponent);
  }

  logout() {
    this.auth.logout();
  }
}
